module.exports = __webpack_public_path__ + "img/homePage.34cb125f.png";